import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import { Link } from 'react-router-dom'

export default function DashboardBox({ title, details, link }) {
    return (

        <Box _hover={{ bgColor: "orange.orange500", color: "#242424" }} color={"#fff"} transition="0.42s" bgColor={"blue.blue500"} m="5px" p="10px" rounded="10px" w={["100%", "45%", "45%", "23%"]} cursor="pointer">
            <Link to={`${link}`}>
                <Text textAlign={"center"} fontWeight="600" fontSize={"16px"} >{title}</Text>
                <Text textAlign={"center"} fontSize="14px">{details}</Text>
            </Link>
        </Box>

    )
}
